import constructMetaObject from './constructMetaObject'
import groupBy from 'lodash.groupby'
import applyToOneOrMany from './applyToOneOrMany'

export default function transformHomeData (data) {
	return applyToOneOrMany(_transformHomeData, data)
}

function _transformHomeData (post) {
	post.fallbackImage = post.native_video_fallback_image ? post.native_video_fallback_image.sizes.bandara_medium : ''
	return post
}



// WEBPACK FOOTER //
// ./src/api/util/transformHomeData.js